import styled from "styled-components";

export const formdiv= styled.div`
position: relative;
top: 30px
`;

export const fieldset = styled.div`
    display: flex;
 
  justify-content: space-around;
`
